import makeService from './api';

export default makeService('profile_tools');
